import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router';

import X, { Color } from '@shared/Icons/X';
import AppContext from '../../../../context';
import { ContextName } from '../../../../appContext/contextName';
import { getLocalStorage, setLocalStorage } from '../../../../utils';
import { showCoronaVirusBanner } from '../../../../utils/localStorage';

import {
  layout,
  covidLinkWrapper,
  covidLink,
  text,
  underlineText,
  closeIcon,
} from './styles.module.css';

const CoronaBanner = () => {
  const {
    [ContextName.COUNTRY_CODE]: countryCode,
    [ContextName.USER_SELECTED_LOCALE]: userSelectedLocale,
  } = useContext(AppContext);

  const loweredCountryCode = (userSelectedLocale || countryCode).toLowerCase();

  // hide by default then check to show it
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(
      (getLocalStorage(showCoronaVirusBanner.key) || '1') === '1' &&
        loweredCountryCode === 'gb',
    );
  }, []);

  const handleHideBanner = (e) => {
    e.stopPropagation();
    setLocalStorage(showCoronaVirusBanner.key, '0');
    setShow(false);
  };

  return show ? (
    <div className={layout}>
      <span className={covidLinkWrapper}>
        <Link
          className={covidLink}
          to="/blog/coronavirus-update-uk"
          rel="nofollow noopener noreferrer"
          target="_blank"
        >
          <span className={text}>
            Book your place at races with C-19 Safety Planning.
          </span>
          <span className={underlineText}>Learn more</span>
        </Link>
      </span>
      <X
        className={closeIcon}
        color={Color.WHITE}
        onClick={(event) => handleHideBanner(event)}
      />
    </div>
  ) : null;
};

CoronaBanner.defaultProps = {};

export default CoronaBanner;
